import styled from 'styled-components'

export const DataTableViewTabStyled = styled.button`
  flex-shrink: 0;
  outline: none;
  border: none;
  appearance: none;
  height: 100%;
  background-color: unset;
  font-family: ${props => props.theme.fontFamilies};
  border: 2px solid ${props => props.theme.colors.white.base};
  color: ${props => props.theme.colors.neutral.base};
  cursor: pointer;

  &:hover,
  &[data-state='open'],
  &[data-selected='true'] {
    border-bottom: 2px solid ${props => props.theme.colors.primary.base};
    color: ${props => props.theme.colors.black.base};
    & > svg {
      color: ${props => props.theme.colors.primary.base};
    }
  }

  & > svg {
    margin-right: ${props => props.theme.spacings.small};
    color: ${props => props.theme.colors.neutral.base};
  }
`
